import { ConfigConcessionaria, ConfigConcessionariaKeys } from "@/models/ConcessionariaModel";
import ApiService from "./ApiService";

export const saveLogAcesso = async (postData) => {
    const { data } = await ApiService.post(`savelog`, postData);
    return data;
};

export const enviarMensagem = async (postData) => {
    const { data } = await ApiService.post(`sms`, postData);
    return data;
};

export const getConcessionarias = async () => {
    const { data } = await ApiService.get(`concessionarialist`);
    return data;
};

export const getConcessionariaByID = async (codConcessionaria) => {
    const { data } = await ApiService.get(`concessionarias/${codConcessionaria}`);
    return data;
};

export const getConcessionariaConfig = async (codConcessionaria: string | number): Promise<ConfigConcessionaria> => {
    const { data } = await ApiService.get(`/config/concessionaria/${codConcessionaria}/list`);
    return data;
};

export const getKeysConcessionaria = async (codConcessionaria: string | number): Promise<ConfigConcessionariaKeys[]> => {
    const { data } = await ApiService.get(`/config/list/keys/${codConcessionaria}`);
    return data;
};

export const updateConfigValueConcessionaria = async (payload) => {
    const { data } = await ApiService.post(`config/update-value`, payload);
    return data;
};

export const sendNotificacao = async (codConcessionaria, postData, dataNotificacao) => {
    const { data } = await ApiService.post(`getnovoorcamento/${codConcessionaria}/${dataNotificacao}`, postData);
    return data;
};

export const setToken = async (postData) => {
    // const { data } = await ApiService.post(`settoken`, postData);
    // return data;
};


export default { setToken, sendNotificacao, enviarMensagem, getConcessionarias, getConcessionariaByID };

